<template>
    <div class="announceDetailPart">
      <p class="title">{{title}}</p>
      <p class="date">{{date}}</p>
      <p v-html="content" class="content"></p>
    </div>
</template>
<script>
export default {
    data(){
        return{
            title: '',
            date: '',
            content: '',
        }
    },
    mounted(){
        let that = this;
        console.log(that.$route.params)
        that.postRequest('/capp-notice/notice/we/chat/open/findNoticeById',{
            noticeId: that.$route.params.noticeId,
            //  appId : 'wxe7bb99f7923d250c',
        appId : sessionStorage.getItem('appId'),
        username : sessionStorage.getItem('userName')
        },function(data){
            console.log(data)
            that.title = data.title
            that.date = data.createTime
            that.content = data.content
        },'n')
    }
}
</script>
<style scoped>
.announceDetailPart {
    text-align: left;
    padding: .2rem .2rem 0;
}
.announceDetailPart .title{
    font-size: .6rem;
}
.announceDetailPart .date{
    color: #999;
    margin: .2rem 0;
}
.announceDetailPart .content{
    color: #666;
    font-size: .36rem;
}
>>> img{
    width: 9rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mingsheng/announceDetail.vue